import axiosInstance from "../../apiAxios/axiosInstance";

// Category List
export const CategoryList = async(payload) => {
  const response= await axiosInstance.post("/vendor/child-category-list",payload);
   return response.data;
};
export const ActiveCategoryList = async(payload) => {
   const resposne=await axiosInstance.post("/vendor/active-child-category-list",payload);
   return resposne.data
};
// Create
export const AddCategory = async(payload) => {
const response= await axiosInstance.post("/vendor/child-category-store", payload);
    return response.data;
};


export const VirwCategory =async (payload) => {
const response=await  axiosInstance.post("/vendor/child-category-show", payload);
    return response.data;
};

// Update
export const UpdateCategory = async(payload) => {
  const response= await axiosInstance.post("/vendor/child-category-update", payload);
    return response.data;
};

// Delete
export const DeleteCategory = async(payload) => {
  const response= await axiosInstance.post("/vendor/child-category-delete", payload);
    return response.data;
};

// Status Change
export const CategoryChangeStatus = async(payload) => {
  const response=await axiosInstance.post("/vendor/child-category-status-update", payload);
    return response.data;
};